import { useIntl } from './useIntl'

export function useOrderViolationTexts() {
  const { translate } = useIntl()

  function getViolationText(violationType: uui.domain.rm.RouteStepViolationsType) {
    switch (violationType) {
      case 'VE':
        return translate({ id: 'rm.scheduler.violations.routeStep.forcedVehicle' })
      case 'TGI':
        return translate({ id: 'rm.scheduler.violations.routeStep.tagsIn' })
      case 'TGO':
        return translate({ id: 'rm.scheduler.violations.routeStep.tagsOut' })
      case 'ELG':
        return translate({ id: 'rm.scheduler.violations.routeStep.eligibility' })
      case 'TW':
        return translate({ id: 'rm.scheduler.violations.routeStep.timeWindow' })
      case 'RGN':
        return translate({ id: 'rm.scheduler.violations.routeStep.region' })
      case 'PDM':
        return translate({ id: 'rm.scheduler.violations.routeStep.missingPaired' })
      case 'PDI':
        return translate({
          id: 'rm.scheduler.violations.routeStep.invertedPickupDelivery',
        })
      case 'OWB':
        return translate({
          id: 'rm.scheduler.violations.routeStep.outsideWorkingTimeBounds',
        })
      default:
        return violationType
    }
  }

  return {
    getViolationText,
  }
}
